import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ActivatedRoute, Router } from '@angular/router';

import { trigger, state, style, animate, transition } from '@angular/animations';

import { OtherService } from 'src/app/Service/other.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import axios from 'src/app/Service/axios';
import { DeviceDetectorService } from 'ngx-device-detector';

declare let $: any;

declare var bootstrap: any;

@Component({

  selector: 'app-driver-info',

  templateUrl: './driver-info.component.html',

  styleUrls: ['./driver-info.component.css'],

  animations: [

    trigger('slideInOut', [

      state(
        'open',
        style({
          height: '*',

          overflow: 'hidden',

          opacity: '1',

          margin: '10px 0',
        })
      ),

      state(
        'closed',
        style({
          height: '0',

          overflow: 'hidden',

          opacity: '0',
        })
      ),

      transition('open <=> closed', [animate('0.4s ease-in-out')]),

    ]),
  ],

})

export class DriverInfoComponent implements OnInit {

  list_AdsImagesCounter: any;

  list_AdsImages: any = [];

  list_AdsImagesShown: any = [];

  information_ads: any = [];

  lst_Album: any[] = [];

  isLogin: boolean;

  isMobile: boolean = false;

  isAlbum: boolean = false;

  albumIndex: number = 0;

  mdl_Validate: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),

    strCode: new FormControl('', Validators.required),

    rating1: new FormControl(''),

  })

  constructor(

    private _otherService: OtherService,

    private formBuilder: FormBuilder,

    private _router: Router,

    private _route: ActivatedRoute,

    private _tooltip: NotificationService,

    private gurdService: GurdServiceService,

    private sanitizer: DomSanitizer,

    private deviceService: DeviceDetectorService,


  ) { }

  ngOnInit(): void {

    this._route.queryParamMap.subscribe((params) => {

      if (params.get('q')) {

        this.mdl_Validate.patchValue({

          strCode: params.get('q')

        })

        this.checkOut_Truck();

        this.isMobile = this.deviceService.isMobile();


      }

    });

  }

  async checkOut_Truck() {

    if(this.mdl_Validate.invalid) return this._tooltip.showError('کد تاکسی را وارد کنید')

    this._otherService.Showspinner();

    const resp = await axios.post(`Taxi_Specifications`, this._otherService.stringNumberToNumber(this.mdl_Validate.value));

    let res = JSON.parse(resp.data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12q1xafg1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    if (res.iResult == -1) {

      return this._tooltip.showError('خطایی در سامانه رخ داده است');

    }

    this.information_ads = {

      ...res,

      list_Gallery: res.lstImages,

      lst_Links: [],

      lstComments: res.lstComments

    };

    this.information_ads.lstHorizontalInfo = [

      { strTitle: 'نوع ', strValue: res.strMobileType_strComment },

      { strTitle: 'گروه ', strValue: res.strMobileGroup_strComment },

    ]

    this.information_ads.lstverticalInfo = [

      { strTitle: 'پلاک خودرو', strValue: res.strVehicleNo.split(' ').reverse().join(' ') },

      { strTitle: 'شناسه تاکسی', strValue: res.strCode },

      { strTitle: 'شهر محل خدمت', strValue: res.strCityName },

      { strTitle: 'نام خط', strValue: res.strTaxiLine },

      { strTitle: 'تعرفه خط(ریال)', strValue: res?.iFee > 0 ? res.iFee.toLocaleString() : '' },

      { strTitle: 'تاریخ دریافت پروانه ', strValue: res.strDefinationDate },

      { strTitle: 'تاریخ اتمام اعتبار پرونده ', strValue: res.strValidDate },

      { strTitle: 'نام خودرو', strValue: res.strGPSType_strComment },

      { strTitle: 'رنگ خودرو', strValue: res.strColor },

    ]

    this.list_AdsImagesCounter = this.information_ads.list_Gallery.length - (this.isMobile ? 2 : 3);

    this.list_AdsImagesShown = this.information_ads.list_Gallery.slice(0, (this.isMobile ? 2 : 3));

    this.mdl_Validate.patchValue({

      rating1: res?.fScore || 0

    })

  }

  show_Warning_Before_Call() {

  }

  getUser_Number() {

  }

  goTo_Support() {

  }

  getSafeHtml(value: string): SafeHtml {

    return this.sanitizer.bypassSecurityTrustHtml(value);

  }

  openGallery(item: any, index?: number) {

    let lst_Gallery = [];

    this.information_ads.list_Gallery.forEach((el) => {

      lst_Gallery.push({ strImage: el })

    })

    this.lst_Album = lst_Gallery;

    this.isAlbum = false;

    this.albumIndex = index;

    setTimeout(() => {

      this.isAlbum = true;

    }, 20);

    $("#galleryComp_Modal").modal('show');

    // var myModal = new bootstrap.Modal(document.getElementById('galleryComp_Modal'), {});

    // myModal.show();

  }

  shareVia() {

    if (navigator.share) {

      navigator
        .share({
          url: window.location.origin + window.location.pathname + `?q=${this.information_ads.strCode}`,

          title: this.information_ads.strFullName,
        })
        .then(() => console.log('اشتراک گذاری موفق'))

        .catch(() =>
          this._tooltip.showError('متاسفانه خطایی رخ داده است')
        );
    }

    else

      this._tooltip.showError('قابلیت اشتراک گذاری برای شما پشتیبانی نمی شود');
  }

}
